import {IRestService} from "./IRestService";
import {IServiceLocator} from "./IServiceLocator";
import {AxiosRestService} from "./AxiosRestService";
import {Lazy} from "../general/Lazy";
import {UserService} from "./UserService";
import {IUserService} from "./IUserService";
import {IAssemblyService} from "./IAssemblyService";
import {AssemblyService} from "./AssemblyService";
import {IPartService} from "./IPartService";
import {PartService} from "./PartService";
import {IVendorService} from "./IVendorService";
import {VendorService} from "./VendorService";
import {AnalyticsService} from "./AnalyticsService";
import {VehicleService} from "./VehicleService";
import {ProductListingService} from "./ProductListingService";

export class ServiceLocator implements IServiceLocator {
	public static readonly Instance: IServiceLocator = new ServiceLocator();
	private readonly restService: Lazy<IRestService>;
	private readonly userService: Lazy<IUserService>;
	private readonly assemblyService: Lazy<IAssemblyService>;
	private readonly partService: Lazy<IPartService>;
	private readonly vendorService: Lazy<IVendorService>;
	private readonly analyticsService: Lazy<AnalyticsService>;
	private readonly vehicleService: Lazy<VehicleService>;
	private readonly productListingService: Lazy<ProductListingService>;

	private constructor() {
		const self = this;
		const createLazy = ServiceLocator.createLazy;

		this.restService = createLazy(() => new AxiosRestService());
		this.userService = createLazy(() => new UserService(self.getRestService()));
		this.assemblyService = createLazy(() => new AssemblyService(self.getRestService()));
		this.partService = createLazy(() => new PartService(self.getRestService()));
		this.vendorService = createLazy(() => new VendorService(self.getRestService()));
		this.analyticsService = createLazy(() => new AnalyticsService());
		this.vehicleService = createLazy(() => new VehicleService(self.getRestService()));
		this.productListingService = createLazy(() => new ProductListingService(self.getRestService()));
	}

	public getRestService(): IRestService {
		return this.restService.getValue();
	}

	public getUserService(): IUserService {
		return this.userService.getValue();
	}

	public getAssemblyService(): IAssemblyService {
		return this.assemblyService.getValue();
	}

	public getPartService(): IPartService {
		return this.partService.getValue();
	}

	public getVendorService(): IVendorService {
		return this.vendorService.getValue();
	}

	public getAnalyticsService() {
		return this.analyticsService.getValue();
	}

	public getVehicleService(): VehicleService {
		return this.vehicleService.getValue();
	}

	public getProductListingService(): ProductListingService {
		return this.productListingService.getValue();
	}

	private static createLazy<T>(getter: () => T): Lazy<T> {
		return new Lazy<T>(getter);
	}
}
